import { useEffect, useState } from "react";
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector,
    GridToolbarExport,
    GridToolbarFilterButton,
    getGridStringOperators,
} from "@mui/x-data-grid";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import styled from "styled-components";
import clearFilterImage from "../../icons/clearFilter.svg"
import searchIcon from "../../icons/searchIcon.svg"
import { Typography, Grid, Box, Button, IconButton, Stack, Select, MenuItem, InputAdornment, TextField, FormControl, InputLabel, Paper, Modal } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import {
    Add, AddAPhoto, AddTask, SaveAlt, SaveAltOutlined, SaveAs, ManageSearch, MobileFriendly, MobileOff,
    Edit, LocationCity, MonetizationOn, Search
} from "@mui/icons-material";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import AddIncentiveModal from '../../components/modals/AddIncentiveModal'
import DeleteIcon from "@mui/icons-material/Delete";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const isMobile = window.innerWidth < 900;

const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile && `position: relative;`}
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : ""};
  margin-bottom: 0px;
  flex-direction: ${isMobile ? "column" : "row"};
`;

const TableContainer = styled.div`
  width: 100%;
  border-radius: 8px;
`;

const DataGridContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? "flex" : "grid"};
  ${isMobile &&
    `
    flex-direction: column;
  `}
`;

export default function IncentiveManagement() {
    const [loading, setLoading] = useState(false);
    const [incentiveModal, setIncentiveModal] = useState(false);
    const [incentiveList, setIncentiveList] = useState(false);
    const [editIncentiveModal, setEditIncentiveModal] = useState(false);
    const [dataModal, setDataModal] = useState();
    const [rowCount, setRowCount] = useState(0);
    const [listRowCount, setlistRowCount] = useState(0);
    const [rowCount1, setRowCount1] = useState(0);
    const [rowCount2, setRowCount2] = useState(0);
    const [dataList, setDataList] = useState([]);
    const [listDataList, setlistDataList] = useState([]);
    const [search, setSearch] = useState("")
    const [seriesFilter, setSeriesFilter] = useState([])
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [selectedseries, setSelectedSeries] = useState("")
    const [dataList1, setDataList1] = useState([]);
    const [dataList2, setDataList2] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rsm, setRsm] = useState("")
    const [rsms, setRsms] = useState([]);
    const [asm, setAsm] = useState("")
    const [asms, setAsms] = useState([]);
    const [rm, setRm] = useState("")
    const [rms, setRms] = useState([]);
    const [selectedCluster, setSelectedCluster] = useState("")
    const [clusters, setClusters] = useState([])
    const [allUsers, setAllUsers] = useState([]);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
    const [incentiveType, setIncentiveType] = useState("percent")
    const [listIncentiveType, setListIncentiveType] = useState("")
    const [schoolOrderModalData, setSchoolOrderModalData] = useState([])
    const [schoolOrderOpenViewModal, setSchoolOrderOpenViewModal] = useState(false)
    const [paginationModel, setPaginationModel] = useState({
        page: currentPage - 1,
        pageSize: 20,
    });
    const [hasSearched, setHasSearched] = useState(false);
 const [sessions, setSessions] = useState([]); // from API
      const [selectedSession, setSelectedSession] = useState("");
      const [isDateRangeDisabled, setIsDateRangeDisabled] = useState(false);
      const [isSessionDisabled, setIsSessionDisabled] = useState(false);
            const [accessModulesData, setAccessModulesData] = useState([]);
      const [filteredDate, setFilteredData] = useState({});

       useEffect(() => {
          fetchSessions();
        }, []);
      
        const fetchSessions = async () => {
          try {
            setLoading(true);
            const response = await window.Platform.database.getAllSessions();
            // if (response?.data) {
            //   setSessions(response.data);
            // }
            if (response?.status) {
           const filterdData1 = response?.data?.filter((ele, ind) => ele?.action == "active")
            setFilteredData(filterdData1[0])
          }
          else {
            window.NotificationUtils.showError("Something Went Wrong in session")
          }
          } catch (error) {
            console.error("Error fetching sessions:", error);
            window.NotificationUtils.showError("Failed to load sessions");
          } finally {
            setLoading(false);
          }
        };
  
          useEffect(() => {
            if (!startDate && !endDate) {
              setIsSessionDisabled(false);
            }
          }, [startDate, endDate]);
        
    useEffect(() => {
        fetchAccessModules();
        getClusterInPicklist()
        if (userData?.role.toLowerCase().includes('admin')) {
            getAllUsers()
        }
        if (userData?.role == 'rsm') {
            getUsers('rsm', userData?.id)
        }
        if (userData?.role == 'asm') {
            getUsers('asm', userData?.id)
        }
    }, [])

    // useEffect(() => {
    //     const handler = setTimeout(() => {
    //         setDebouncedSearch(search);
    //     }, 500);
    //     return () => clearTimeout(handler);
    // }, [search]);

    useEffect(() => {
        getSeriesCategory()
    }, [])

    useEffect(() => {
        if(hasSearched){
            if (incentiveList) {
                if (incentiveType === "percent") {
                    getIncentiveList();
                } else {
                    getIncentiveRules();
                }
            }
            else{
                if (listIncentiveType === "percent") {
                    setlistDataList([]);
                    setlistRowCount(0);
                    GetAllIncentives();
                } else if(listIncentiveType === "condition") {
                    setDataList([])
                    setRowCount(0);
                    GetAllListIncentives();
                }
            }
        }
}, [paginationModel.page, paginationModel.pageSize, incentiveType, listIncentiveType]);

    const formatTimeStamp = (timestampFromDB) => {
        const options = {
            timeZone: "Asia/Kolkata",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: true,
        };
        const formattedDate = new Date(timestampFromDB).toLocaleString("en-US", options);
        return formattedDate;
    };

    const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId : userData?.id,
                moduleId : "zUcuserbra"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }

    const getClusterInPicklist = async () => {
        setLoading(true);
        try {
            let results = await window.Platform.database.getClusterInPicklist();

            const jsonArrayWithId = results?.data?.map((obj) => ({
                ...obj,
                dbId: obj.id
            }));


            setClusters(jsonArrayWithId);
            setLoading(false);
        } catch (error) {
            console.error("ERRORCHECK", error);
            setLoading(false);
        }
    };

    async function getAllUsers() {
        let results = await window.Platform.database.fetchEmployees()
        setAllUsers(results?.data)
        setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
        setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
        setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
    }

    async function getUsers(role, id) {
        if (id != "") {
            let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
            if (role == 'rsm') {
                setAsms(results?.data)
                setRms(results?.data1)
            }
            if (role == 'asm') {
                setRms(results?.data)
            }
        } else {
            if (role == 'rsm') {
                setRm("")
                setAsm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
                setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
            }

            if (role == 'asm') {
                setRm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
            }
        }

    }

    const getSeriesCategory = async () => {
        setLoading(true);
        try {
            let results = await window.Platform.database.getSeriesCategory();
            if (results?.message == "Session Expired Please LogIn Again") {
                window.NotificationUtils.showError(results?.message)
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj) => ({
                    ...obj,
                    dbId: obj.id
                }));

                setSeriesFilter(jsonArrayWithId);
                setLoading(false);
            }
        } catch (error) {
            console.error("ERRORCHECK", error);
            setLoading(false);
        }
    };

    const getIncentiveList = async () => {
        // setIncentiveType("percent");
        setLoading(true);
        try {
            let results = await window.Platform.database.getIncentiveList({ pageNumber: paginationModel.page, recordPerPage: paginationModel.pageSize });
            setRowCount1(results?.data1);
            setDataList1(results?.data);
            setLoading(false);
        } catch (error) {
            window.NotificationUtils.showError("Data not found");
            setLoading(false);
        }
    }

    const getIncentiveRules = async () => {
        // setIncentiveType("condition");
        setLoading(true);
        try {
            let results = await window.Platform.database.getIncentiveRules({ pageNumber: paginationModel.page, recordPerPage: paginationModel.pageSize });
            if(results?.status){
                setRowCount2(results?.data1);
                setDataList2(results?.data);
                setLoading(false);
            }
            else{
                setLoading(false);
            }
        } catch (error) {
            window.NotificationUtils.showError("Data not found");
            setLoading(false);
        }
    }


    const handleClearFilters = async () => {
        setListIncentiveType("")
        setStartDate("")
        setEndDate("")
        setSelectedSeries("")
        setSearch("")
        setRsm("")
        setAsm("")
        setRm("")
        setSelectedCluster("")
        setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
        setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
        setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
        setPaginationModel((prev) => ({ ...prev, pageSize: 20 }))
          setDataList([]);
          setlistDataList([])
          setHasSearched(false);
    setRowCount(0);
    setlistRowCount(0);
    setSelectedSession("");
    setIsDateRangeDisabled(false);
    setIsSessionDisabled(false);
    setSelectedSession("");
    setLoading(false);
        // GetAllIncentives()
    }

    const GetAllIncentives = async () => {

        setLoading(true);

        let data = {
            pageNumber: paginationModel.page,
            recordPerPage: paginationModel.pageSize,
            search: search,
            selectedSeries: selectedseries,
            // startDate: startDate,
            // endDate: endDate,
          startDate: startDate != '' ? startDate : filteredDate?.startDate,
          endDate: endDate != '' ? endDate : filteredDate?.endDate,
            selectedUserId: ((rsm && asm && rm) ? rm : (rsm && asm) ? asm : (rsm && rm) ? rm : (asm && rm) ? rm : rsm ? rsm : "") || ((rsm && asm && rm) ? rm : (rsm && asm) ? asm : (rsm && rm) ? rm : (asm && rm) ? rm : asm ? asm : "") || ((rsm && asm && rm) ? rm : (rsm && asm) ? asm : (rsm && rm) ? rm : (asm && rm) ? rm : rm ? rm : "") || "",
            selectedCluster: selectedCluster
        }

        try {
            let results = await window.Platform.database.GetAllIncentives(data);

            setRowCount(results?.totalRecords);
            setDataList(results?.data);
            setLoading(false);
            // window.NotificationUtils.showError(results.message)
        } catch (error) {
            window.NotificationUtils.showError("Data not found");
            setLoading(false);
        }
    };

      const GetAllListIncentives = async () => {

        setLoading(true);

        let data = {
            pageNumber: paginationModel.page,
            recordPerPage: paginationModel.pageSize,
            search: search,
            selectedSeries: selectedseries,
            // startDate: startDate,
            // endDate: endDate,
          startDate: startDate != '' ? startDate : filteredDate?.startDate,
          endDate: endDate != '' ? endDate : filteredDate?.endDate,
            selectedUserId: ((rsm && asm && rm) ? rm : (rsm && asm) ? asm : (rsm && rm) ? rm : (asm && rm) ? rm : rsm ? rsm : "") || ((rsm && asm && rm) ? rm : (rsm && asm) ? asm : (rsm && rm) ? rm : (asm && rm) ? rm : asm ? asm : "") || ((rsm && asm && rm) ? rm : (rsm && asm) ? asm : (rsm && rm) ? rm : (asm && rm) ? rm : rm ? rm : "") || "",
            selectedCluster: selectedCluster
        }

        try {
            let results = await window.Platform.database.calculateIncentiveForAllUsers(data);

            setlistRowCount(results?.totalRecords);
            setlistDataList(results?.data);
            setLoading(false);
            // window.NotificationUtils.showError(results.message)
        } catch (error) {
            window.NotificationUtils.showError("Data not found");
            setLoading(false);
        }
    };

    const deleteIncentive = async (id) => {

        const confirmDelete = window.confirm("Are you sure you want to delete this Incentive ?");
        if (!confirmDelete) return;

        try {
            setLoading(true);

            const response = await window.Platform.database.deleteIncentive({ id });


            window.NotificationUtils.showSuccess("Incentive deleted successfully");

            //   GetAllIncentives();
            getIncentiveList()

        } catch (error) {
            console.error("Error deleting the Incentive:", error);
            window.NotificationUtils.showError("Error deleting the Incentive");
        } finally {
            setLoading(false);
        }
    }

    const deleteIncentiveRule = async (id) => {

        const confirmDelete = window.confirm("Are you sure you want to delete this Incentive ?");
        if (!confirmDelete) return;

        try {
            setLoading(true);

            const response = await window.Platform.database.deleteIncentiveRule({ id });


            window.NotificationUtils.showSuccess("Incentive deleted successfully");

            //   GetAllIncentives();
            getIncentiveRules()

        } catch (error) {
            console.error("Error deleting the Incentive:", error);
            window.NotificationUtils.showError("Error deleting the Incentive");
        } finally {
            setLoading(false);
        }
    }

    const handleEdit = (data) => {
        console.log(data,"asasasasas")
        setDataModal(data);
        setEditIncentiveModal(true);
        setIncentiveModal(false);
    };

     const handleCloseSchoolOrderViewModal = () => {
    setSchoolOrderOpenViewModal(false);
    setSchoolOrderModalData([]);
  }
 const handleOpenSchoolOrderViewModal = (id) => {
    console.log(id)
    setSchoolOrderModalData(id)
    setSchoolOrderOpenViewModal(true);
  }

      const getIncentiveColumnsNew1 = () => {
        const stringOperators = getGridStringOperators().filter((op) => ["contains"].includes(op.value));

        return [
            {
                field: "Role",
                headerName: "Role",
                width: 130,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.user_role || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.user_role == "se" ? "RM" : params.row?.user_role?.toUpperCase() || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.user_role == "se" ? "RM" : params.row?.user_role?.toUpperCase() || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
            {
                field: "Series Name",
                headerName: "Series Name",
                width: 170,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.seriesName?.split(" ")
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                    .join(" ") || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.seriesName?.split(" ")
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                        .join(" ") || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.seriesName?.split(" ")
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                            .join(" ") || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
           
            {
                field: "SchoolCount1",
                headerName: "School Count",
                width: 130,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.minSchool || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.minSchool || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.minSchool || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
             {
                field: "Criteria",
                headerName: "Criteria",
                width: 180,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.minBooks || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.minBooks || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.minBooks || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
             {
                field: "studentCount1",
                headerName: "Student Count",
                width: 150,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.minStudents || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.minStudents || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.minStudents || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
             {
                field: "Percent1",
                headerName: "Incentive Percent",
                width: 150,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.incentivePercent || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.incentivePercent || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.incentivePercent + " %" || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
            (accessModulesData && accessModulesData[0]?.is_delete?.toLowerCase() != "no" || accessModulesData && accessModulesData[0]?.is_update?.toLowerCase() != "no") &&   {
                field: "actions",
                headerName: "Actions",
                width: 120,
                filterable: false,
                sortable: false,
                disableExport: true,
                renderCell: (params) => (
                    <>
                        {accessModulesData && accessModulesData[0]?.is_update?.toLowerCase() != "no" && <Tooltip title="Edit Incentive">
                            <IconButton onClick={() => handleEdit(params.row)}>
                                <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "500" }} />
                            </IconButton>
                        </Tooltip>}
                       {accessModulesData && accessModulesData[0]?.is_delete?.toLowerCase() != "no" &&  <Tooltip title="Delete Incentive">
                            <IconButton onClick={() => deleteIncentiveRule(params.row?.id)}>
                                <DeleteIcon sx={{ color: "red", fontSize: "22px", fontWeight: "500" }} />
                            </IconButton>
                        </Tooltip>}
                    </>
                ),
            },

        ];
    };


    const getIncentiveColumnsNew = () => {
        const stringOperators = getGridStringOperators().filter((op) => ["contains"].includes(op.value));

        return [
            {
                field: "Role",
                headerName: "Role",
                width: 170,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.role || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.role == "se" ? "RM" : params.row?.role?.toUpperCase() || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.role == "se" ? "RM" : params.row?.role?.toUpperCase() || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
            {
                field: "Series Name",
                headerName: "Series Name",
                width: 170,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.seriesName?.split(" ")
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                    .join(" ") || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.seriesName?.split(" ")
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                        .join(" ") || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.seriesName?.split(" ")
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                            .join(" ") || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
            {
                field: "Percent",
                headerName: "Incentive Percent",
                width: 150,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.incentivePercent || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.incentivePercent || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.incentivePercent || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
            (accessModulesData && accessModulesData[0]?.is_delete?.toLowerCase() != "no" || accessModulesData && accessModulesData[0]?.is_update?.toLowerCase() != "no") &&   {
                field: "actions",
                headerName: "Actions",
                width: 120,
                filterable: false,
                sortable: false,
                disableExport: true,
                renderCell: (params) => (
                    <>
                        {accessModulesData && accessModulesData[0]?.is_update?.toLowerCase() != "no" && <Tooltip title="Edit Incentive">
                            <IconButton onClick={() => handleEdit(params.row)}>
                                <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "500" }} />
                            </IconButton>
                        </Tooltip>}
                       {accessModulesData && accessModulesData[0]?.is_delete?.toLowerCase() != "no" &&  <Tooltip title="Delete Incentive">
                            <IconButton onClick={() => deleteIncentive(params.row?.id)}>
                                <DeleteIcon sx={{ color: "red", fontSize: "22px", fontWeight: "500" }} />
                            </IconButton>
                        </Tooltip>}
                    </>
                ),
            },

        ];
    };

    const getIncentiveColumns = () => {
        const stringOperators = getGridStringOperators().filter((op) => ["contains"].includes(op.value));

        return [
            {
                field: "Name",
                headerName: "Name",
                width: 230,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.ownerName || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.ownerName || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.ownerName || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
            {
                field: "Series Name",
                headerName: "Series",
                width: 150,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.seriesName?.split(" ")
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                    .join(" ") || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.seriesName?.split(" ")
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                        .join(" ") || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.seriesName?.split(" ")
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                            .join(" ") || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
            {
                field: "Amount",
                headerName: "Amount",
                width: 150,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.amount || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.amount || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.amount || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
            {
                field: "Percent",
                headerName: "Incentive Percent",
                width: 150,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.percent || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.percent || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.percent || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
            {
                field: "SO ID",
                headerName: "Reference Sales Order",
                width: 200,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.so_id || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.so_id || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.so_id || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
            {
                field: "Area Name",
                headerName: "Area Name",
                width: 200,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.clusterName || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.clusterName || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.clusterName || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
            // {
            //     field: "UpdatedAt",
            //     headerName: "updatedAt",
            //     width: 250,
            //     filterable: true,
            //     sortable: false,
            //     valueGetter: (params) => formatTimeStamp(params.row?.updatedAt) || "N/A",
            //     renderCell: (params) => (
            //         <Tooltip title={formatTimeStamp(params.row?.updatedAt) || "N/A"}>
            //             <Typography variant="inherit">{formatTimeStamp(params.row?.updatedAt) || "N/A"}</Typography>
            //         </Tooltip>
            //     ),
            // },
            // {
            //     field: "actions",
            //     headerName: "Actions",
            //     width: 250,
            //     filterable: false,
            //     sortable: false,
            //     disableExport: true,
            //     renderCell: (params) => (
            //         <>
            //             <Tooltip title="Edit Incentive">
            //                 <IconButton onClick={() => handleEdit(params.row)}>
            //                     <DriveFileRenameOutlineIcon />
            //                 </IconButton>
            //             </Tooltip>
            //             <Tooltip title="Delete Incentive">
            //                 <IconButton onClick={() => deleteIncentive(params.row?.id)}>
            //                     <DeleteIcon />
            //                 </IconButton>
            //             </Tooltip>
            //         </>
            //     ),
            // },
        ];
    };

    const getIncentiveColumns1Rs = () => {
        const stringOperators = getGridStringOperators().filter((op) => ["contains"].includes(op.value));

        return [
            {
                field: "Name",
                headerName: "Name",
                width: 230,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.userName || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.userName || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.userName || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
            {
                field: "Amount",
                headerName: "EMP ID",
                width: 150,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.empId || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.empId || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.empId || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
            {
                field: "Percent",
                headerName: "Total Incentive",
                width: 250,
                filterable: true,
                sortable: false,
                valueGetter: (params) => params.row?.totalIncentive?.toFixed(2)  || "N/A",
                renderCell: (params) => (
                    <Tooltip title={params.row?.totalIncentive?.toFixed(2)  || "N/A"}>
                        <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row?.totalIncentive?.toFixed(2) || "N/A"}</Typography>
                    </Tooltip>
                ),
            },
            {
                field: "View",
                headerName: "View Details",
                width: 200,
                sortable: false,
                renderCell: (params) => {
                    return (
                        <>
                            <Tooltip>
                                <span>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={() => handleOpenSchoolOrderViewModal(params.row)}
                                        sx={{ minWidth: "70px" }}
                                    >
                                        {"View"}
                                    </Button>
                                </span>
                            </Tooltip>
                            <Modal open={schoolOrderOpenViewModal} onClose={handleCloseSchoolOrderViewModal}>
                                <Box sx={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "80%", bgcolor: "white", boxShadow: 24, p: 5, borderRadius: 2, maxHeight: "90%", overflowY: "auto", position: "fixed", overflow: "auto", }}>
                                    <Typography variant="h6" component="h2" mb={1} style={{ textAlign: "center" }}> Incentive Detail </Typography>
                                    <hr style={{ width: "100%", color: "#000", borderTop: "1px solid black" }} />
                                    <div>
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <b style={{fontSize:"16px", fontWeight:"600", color:"#000"}}> Name: - </b> <span style={{fontSize:"14px", fontWeight:"500", color:"#000"}}>{schoolOrderModalData?.userName || "N/A"}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <b style={{fontSize:"16px", fontWeight:"600", color:"#000"}}> EMP ID: - </b> <span style={{fontSize:"14px", fontWeight:"500", color:"#000"}}>{schoolOrderModalData?.empId || "N/A"}</span>
                                            </div>
                                            <div className="col-12 mt-3">
                                                <table>
                                                    <tr>
                                                        <th style={{fontSize:"14px", fontWeight:"600", textAlign:"center"}}>Series Name</th>
                                                        <th style={{fontSize:"14px", fontWeight:"600", textAlign:"center"}}>School Count</th>
                                                        <th style={{fontSize:"14px", fontWeight:"600", textAlign:"center"}}>Book Count / Criteria</th>
                                                        <th style={{fontSize:"14px", fontWeight:"600", textAlign:"center"}}>Student Count</th>
                                                        <th style={{fontSize:"14px", fontWeight:"600", textAlign:"center"}}>Incentive Percent</th>
                                                        <th style={{fontSize:"14px", fontWeight:"600", textAlign:"center"}}>Incentive Amount</th>
                                                        <th style={{fontSize:"14px", fontWeight:"600", textAlign:"center"}}>Total Amount</th>
                                                    </tr>
                                                    {schoolOrderModalData?.incentiveData?.map((ele, ind) => {
                                                        return <tr>
                                                            <td style={{fontSize:"12px", fontWeight:"600", textAlign:"center"}}>{ele?.seriesName || "N/A"}</td>
                                                            <td style={{fontSize:"12px", fontWeight:"600", textAlign:"center"}}>{ele?.schoolCount || 0}</td>
                                                            <td style={{fontSize:"12px", fontWeight:"600", textAlign:"center"}}>{ele?.bookCount || 0}</td>
                                                            <td style={{fontSize:"12px", fontWeight:"600", textAlign:"center"}}>{ele?.studentCount || 0}</td>
                                                            <td style={{fontSize:"12px", fontWeight:"600", textAlign:"center"}}>{ele?.incentivePercent || 0}</td>
                                                            <td style={{fontSize:"12px", fontWeight:"600", textAlign:"center"}}>{ele?.incentiveAmount || 0}</td>
                                                            <td style={{fontSize:"12px", fontWeight:"600", textAlign:"center"}}>{ele?.totalAmount || 0}</td>
                                                        </tr>
                                                    })}
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <Box mt={2} display="flex" justifyContent="flex-end">
                                        <Button onClick={handleCloseSchoolOrderViewModal} variant="contained" color="primary">
                                            Close
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    );
                },
            },
        ];
    };

    const renderContent = () => {
        return (
            <>
                  {incentiveList && <div className="d-flex justify-content-between align-items-center py-2 px-3">
                  <Box sx={{ display: "flex", gap: 4, alignItems: "center" }}>
                    <Button
                    //   onClick={() => {getIncentiveList();}}
                    onClick={() => setIncentiveType("percent")}
                      sx={{
                        width: 250,
                        fontSize: "13px",
                        backgroundColor: incentiveType == "percent" ? "#009c2a" : "#6e8091" ,
                        color: "#fff" ,
                        "&:hover": {
                          backgroundColor: "#1565c0" ,
                        },
                      }}
                    >
                      Percent Wise Incentive
                    </Button>
                    <Button
                    //   onClick={() => {getIncentiveRules(); }}
                     onClick={() => setIncentiveType("condition")}
                      sx={{
                        width: 250,
                        backgroundColor: incentiveType == "condition" ? "#04820c" :"#6e8091",
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: "#1565c0",
                        },
                      }}
                    >
                      Condition Wise Incentive
                    </Button>
                  </Box>
                </div>}
                <DataGridContainer style={{ height: incentiveList ? "auto" : !dataList.length ? !listDataList.length ? "200px" : "auto" : incentiveType == "percent" ? "auto" : incentiveType == "condition" ?  "auto": "auto" }}>
  <DataGrid
    className="payrollGrid"
    density="compact"
    rows={
      !incentiveList
        ? listIncentiveType === "percent"
          ? dataList
          : listDataList
        : incentiveType === "percent"
        ? dataList1
        : dataList2 || []
    }
    columns={
      !incentiveList
        ? listIncentiveType === "percent"
          ? getIncentiveColumns()
          : getIncentiveColumns1Rs()
        : incentiveType === "percent"
        ? getIncentiveColumnsNew()
        : getIncentiveColumnsNew1()
    }
    sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
    disableSelectionOnClick
    disableRowSelectionOnClick
    paginationModel={paginationModel}
    paginationMode="server"
    onPaginationModelChange={setPaginationModel}
    rowCount={
      !incentiveList
        ? listIncentiveType === "percent"
          ? rowCount
          : listRowCount
        : incentiveType === "percent"
        ? rowCount1
        : rowCount2
    }
    getRowId={(row, index) =>
      !incentiveList
        ? listIncentiveType === "percent"
          ? `${row?.id}-${row?.ownerId}-${row?.seriesId}-${row?.so_id}-${row?.updatedAt}-${index}`
          : `${row?.ownerId}-${index}`
        : incentiveType === "percent"
        ? `${row?.id}-${row?.updatedAt}-${index}`
        : `${row?.id}-${row?.updatedAt}-${index}`
    }
    components={{
      Toolbar: CustomToolbar,
    }}
  />
</DataGridContainer>
            </>
        );
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer className="d-flex justify-content-end align-items-center mr-2">
                <Typography variant="body1" className="ml-4" sx={{ color: "black", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
                <Select
                    value={paginationModel.pageSize}
                    variant="outlined"
                    size="small"
                    onChange={(e) => { setHasSearched(true); setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
                    sx={{ width: 90, fontSize: 14, fontWeight: "500", color: "black" }}
                >
                    {[10, 20, 30, 50, 100].map((role) => (
                        <MenuItem key={role} value={role} sx={{ color: "black", fontWeight: "500" }}>{role}</MenuItem>
                    ))}
                </Select>
            </GridToolbarContainer>
        );
    }

    async function goToIncentiveList() {
        setIncentiveList(true);
        getIncentiveList()
         setListIncentiveType("");
    }

    const addIncentive = () => {
        setIncentiveModal(true);
        // setIncentiveList(true)
    };

    const exportIncentive = async () => {


        setLoading(true);
        try {
            let data = {
                search: search,
                selectedSeries: selectedseries,
                // startDate: startDate,
                // endDate: endDate,
          startDate: startDate != '' ? startDate : filteredDate?.startDate,
          endDate: endDate != '' ? endDate : filteredDate?.endDate,
                selectedUserId: ((rsm && asm && rm) ? rm : (rsm && asm) ? asm : (rsm && rm) ? rm : (asm && rm) ? rm : rsm ? rsm : "") || ((rsm && asm && rm) ? rm : (rsm && asm) ? asm : (rsm && rm) ? rm : (asm && rm) ? rm : asm ? asm : "") || ((rsm && asm && rm) ? rm : (rsm && asm) ? asm : (rsm && rm) ? rm : (asm && rm) ? rm : rm ? rm : "") || "",
                selectedCluster: selectedCluster
            }
            let result = await window.Platform.database.exportData("/incentive/ExportIncentivesToExcel",
                data
            )
            console.log(result.data, "API Response Data");

            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "incentive.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Export error:", error);
        }
    }

    return (
        <>
            <StaffEditorPageContainer>
                {loading && <OpaqueLoading />}
                <Paper elevation={3}
                    sx={{
                        p: 2,
                        mb: 2,
                        width: '100%',        // takes full width of parent
                        // maxWidth: '1000px',   // optional: control max width
                        mx: 'auto',
                        backgroundColor: "#ebf0fa"          // center it horizontally
                    }}>
                    <div className="container-fluid" style={{ width: "100%" }}></div>
                    <HeaderContainer>
                        <div className="row w-100" >
                            {!incentiveList &&
                                <>
                                    <div className="col-md-3">
                                        {/* <Typography variant="body1" className="" sx={{color:"black", fontSize:"14px", fontWeight:"500"}}>Search:</Typography> */}
                                        <TextField
                                            label="Search By Name"
                                            // variant="outlined"
                                            size="small"
                                            placeholder="Type To  Search"
                                            // className="mt-3"
                                            fullWidth
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)} // Proper event handler
                                            sx={{ fontSize: 14, color: "black" }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Search color="action" />
                                                    </InputAdornment>
                                                ),
                                                style: { fontSize: 16, color: "black", fontWeight: "500" }
                                            }}
                                            InputLabelProps={{
                                                style: { color: "black", fontSize: "16px" }, // Label color
                                            }}
                                        />
                                    </div>

                                    {userData?.role.includes('admin') && <div className="col-md-2">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                                            <Select
                                                value={rsm}
                                                label="Select HO"
                                                size="small"
                                                fullWidth
                                                onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value) }}
                                                sx={{ fontSize: 14, fontWeight: "500" }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                                {rsms.map((role) => (
                                                    <MenuItem key={role} value={role?.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role?.name} - {role.username}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    {userData?.role != 'asm' && <div className="col-md-2">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                                            <Select
                                                value={asm}
                                                label="Select ARM"
                                                fullWidth
                                                size="small"
                                                onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value) }}
                                                sx={{ fontSize: 14, fontWeight: "500" }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                                {asms.map((role) => (
                                                    <MenuItem key={role} value={role?.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role?.name} - {role.username}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    <div className="col-md-2">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM</InputLabel>
                                            <Select
                                                label="Select RM"
                                                value={rm}
                                                size="small"
                                                fullWidth
                                                onChange={(e) => { setRm(e.target.value) }}
                                                sx={{ fontSize: 14, fontWeight: "500" }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                                {rms.map((role) => (
                                                    <MenuItem key={role} value={role?.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role?.name} - {role.username}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>

                                    <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel className="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Series</InputLabel>
                                            <Select
                                                label="Select Series"
                                                value={selectedseries}
                                                size="small"
                                                fullWidth
                                                onChange={(e) => { setSelectedSeries(e.target.value) }}
                                                sx={{ fontSize: 14, fontWeight: "500", color: "black" }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                                {seriesFilter.filter((t) => t?.incentiveApplied).map((role) => (
                                                    <MenuItem key={role} value={role?.seriesTableId} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role?.seriesName}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    {/* <div >
                                    <Typography variant="body1" sx={{color:"black", fontSize:"13px", fontWeight:"500"}}>Select Cluster:</Typography>
                                    <Select
                                        value={selectedCluster}
                                        variant="outlined"
                                        size="small"
                                        onChange={(e) => { setSelectedCluster(e.target.value) }}
                                        sx={{ width: 170, fontSize: 13, fontWeight:"500" }}
                                    >
                                        <MenuItem value="" sx={{color:"black", fontSize:"13px", fontWeight:"500"}}>All</MenuItem>
                                        {clusters.map((role) => (
                                            <MenuItem key={role} value={role?.id} sx={{color:"black", fontSize:"13px", fontWeight:"500"}}>{role?.name}</MenuItem>
                                        ))}
                                    </Select>
                                </div> */}
                                </>}

                        </div>
                    </HeaderContainer>
                    <div className="row w-100 mt-3">
                      {!incentiveList &&  <div className="col-md-3">
                            <FormControl fullWidth size="small">
                                <InputLabel sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Area</InputLabel>
                                <Select
                                    label="Select Area"
                                    value={selectedCluster}
                                    size="small"
                                    fullWidth
                                    onChange={(e) => { setSelectedCluster(e.target.value) }}
                                    sx={{ fontSize: 13, fontWeight: "500" }}
                                >
                                    <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                    {clusters.map((role) => (
                                        <MenuItem key={role} value={role?.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role?.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>}
                        {!incentiveList &&
                            <div className=" col-md-9">
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item>
                                        <FormControl fullWidth size="small">
                                            <TextField label="From Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={startDate} 
                                            // onChange={(e) => setStartDate(e.target.value)}
                                              disabled={isDateRangeDisabled}
                        onChange={(e) => {
                        const value = e.target.value;
                        setStartDate(value);
                        if (value) {
                          setIsSessionDisabled(true);
                          setSelectedSession("");
                        } else if (!value && !endDate) {
                          setIsSessionDisabled(false);
                        }
                      }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }}
                                                inputProps={{
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item >
                                        <FormControl fullWidth size="small">
                                            <TextField label="To Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={endDate} 
                                            // onChange={(e) => setEndDate(e.target.value)}
                                              disabled={isDateRangeDisabled}
                      onChange={(e) => {
                        const value = e.target.value;
                        setEndDate(value);
                        if (value) {
                          setIsSessionDisabled(true);
                          setSelectedSession("");
                        } else if (!value && !startDate) {
                          setIsSessionDisabled(false);
                        }
                      }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }}
                                                inputProps={{
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }} />
                                        </FormControl>
                                    </Grid>

                                    <Grid item>
                                        <Button variant="contained"
                                            fullWidth
                                            size="small"
                                            sx={{ fontSize: '14px', borderRadius: '10px', width: 100 }}
                                            // onClick={() => { setHasSearched(true); listIncentiveType == "percent" ? GetAllIncentives() : listIncentiveType == "condition" ? GetAllListIncentives() : ""}}
                                            onClick={() => { setHasSearched(true);
                                                if (listIncentiveType === "percent") GetAllIncentives();
                                                else if (listIncentiveType === "condition") GetAllListIncentives();
                                            }}
                                            // disabled={!startDate && !endDate}
                                            startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />}
                                        >
                                            Find
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button variant="contained" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} color="secondary" fullWidth size="small" sx={{ fontSize: '13px', borderRadius: '10px', width: "100%" }}
                                            onClick={() => handleClearFilters()}
                                        >
                                            Clear Filters
                                        </Button>
                                    </Grid>
                                   {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" &&  <Grid item>
                                        <Button
                                            variant="contained"
                                            color="success"
                                            fullWidth
                                            onClick={() => exportIncentive()}
                                            //   onClick={() => addIncentive()}
                                            sx={{ mr: 1, borderRadius: "10px" }}
                                        >
                                            <FileDownloadIcon sx={{ mr: 1 }} />
                                            Download
                                        </Button>
                                    </Grid>}
                                </Grid>
                            </div>}
                    </div>
                      {!incentiveList && <div className="row mt-2">
                {/* <div className="col-md-3">
                                                        <FormControl fullWidth size="small">
                                                          <InputLabel
                                                            sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                          >
                                                            Select Session
                                                          </InputLabel>
                                                          <Select
                                                            label="Select Session"
                                                            value={selectedSession}
                                                            disabled={isSessionDisabled}
                                                            sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                            onChange={(e) => {
                                                              const selected = sessions.find((item) => item.id === e.target.value);
                                                              setSelectedSession(e.target.value);
                                    
                                                              if (selected) {
                                                                // ✅ Convert UTC → IST (local date)
                                                                const start = new Date(selected.startDate);
                                                                const end = new Date(selected.endDate);
                                    
                                                                const startIST = new Date(start.getTime() + (5.5 * 60 * 60 * 1000))
                                                                  .toISOString()
                                                                  .split("T")[0];
                                                                const endIST = new Date(end.getTime() + (5.5 * 60 * 60 * 1000))
                                                                  .toISOString()
                                                                  .split("T")[0];
                                    
                                                                setStartDate(startIST);
                                                                setEndDate(endIST);
                                    
                                                                // ✅ Disable manual date range if session chosen
                                                                setIsDateRangeDisabled(true);
                                                              } else {
                                                                // ✅ If cleared, re-enable date inputs
                                                                setIsDateRangeDisabled(false);
                                                              }
                                                            }}
                                    
                                                          >
                                                            <MenuItem value="">
                                                              <em>Select Session</em>
                                                            </MenuItem>
                                                            {sessions.map((s) => (
                                                              <MenuItem key={s.id} value={s.id}>
                                                                {s.sessionName}
                                                              </MenuItem>
                                                            ))}
                                                          </Select>
                                                        </FormControl>
                                                      </div> */}
              </div>}
                </Paper>
                  <div>
                  {!incentiveList &&  <Box sx={{ display: "flex", gap: 4 }}>
                    <Button
                    //   onClick={() => {getIncentiveList();}}
                    onClick={() => setListIncentiveType("percent")}
                      sx={{
                        width: 250,
                        fontSize: "13px",
                        backgroundColor: listIncentiveType == "percent" ? "#009c2a" : "#6e8091" ,
                        color: "#fff" ,
                        "&:hover": {
                          backgroundColor: "#1565c0" ,
                        },
                      }}
                    >
                      Percent Wise Incentive
                    </Button>
                    <Button
                    //   onClick={() => {getIncentiveRules(); }}
                     onClick={() => setListIncentiveType("condition")}
                      sx={{
                        width: 250,
                        backgroundColor: listIncentiveType == "condition" ? "#04820c" :"#6e8091",
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: "#1565c0",
                        },
                      }}
                    >
                      Condition Wise Incentive
                    </Button>
                  </Box>}
                <Box display="flex" justifyContent="flex-end" gap={2}>

                    {/* <div className="row w-100 mt-3"> */}
                    <div className="col-md-3 mb-2">
                        {!incentiveList ? <Button
                            variant="contained"
                            fullWidth
                            color="primary"
                            sx={{ borderRadius: "10px" }}
                            onClick={() => goToIncentiveList(true)}
                        >
                            Configure Incentive
                        </Button>
                            :
                            <div className="d-flex justify-content-between align-items-center">
                                {/* <ArrowBackIcon sx={{ color: "black", fontSize: "22px", fontWeight: "500" }} /> */}
                                <IconButton
                                    aria-label="back"
                                    onClick={() => { setIncentiveList(false); setIncentiveType("percent"); setHasSearched(false); setListIncentiveType("") }}
                                >
                                    <ArrowBackIcon sx={{ color: "black", fontSize: "22px", fontWeight: "500" }} />
                                </IconButton>
                                {accessModulesData && accessModulesData[0]?.is_add?.toLowerCase() != "no" &&  <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    sx={{ mr: 1, borderRadius: "10px" }}
                                    onClick={() => addIncentive()}
                                >
                                    Add Incentive
                                </Button>}
                            </div>
                        }
                    </div>
                    {/* </div> */}
                </Box>
                  </div>
                <TableContainer>{renderContent()}</TableContainer>
            </StaffEditorPageContainer>
            {incentiveModal && (
                <AddIncentiveModal
                    onClose={() => setIncentiveModal(false)}
                    fetchData={() => {incentiveType == "perrcent" ? getIncentiveList() : getIncentiveRules();}}
                />
            )}
            {editIncentiveModal && (
                <AddIncentiveModal
                    onClose={() => setEditIncentiveModal(false)}
                    fetchData={() => {incentiveType == "perrcent" ? getIncentiveList() : getIncentiveRules();}}
                    props={dataModal}
                />
            )}
        </>
    );
}
